import React from "react";
import { useIntl } from "react-intl";
import StoreBadges from "../../pages/home/MobileApp/StoreBadges/StoreBadges";
import { amazonHost } from "../../paths";
import messages from "./messages";
import { AppLogoExt, Container } from "./styles";

const StudentApplicationAd = () => {
    const { formatMessage } = useIntl();
    return (
        <Container>
            <AppLogoExt
                src={`${amazonHost}landing/app-logo.svg`}
            />
            <h2>
                {formatMessage(messages.title)}
            </h2>
            <p>
                {formatMessage(messages.description)}
            </p>
            <StoreBadges onlyCurrentPlatform />
        </Container>
    );
};

export default StudentApplicationAd;
